import React from 'react'
import styles from '@/pages/scss/Accessories.module.scss'
import { Box } from '@mui/material'
import { InteractiveButton, Typography } from '@evocolabs/orkaui'

const Video = ({ poster, video }) => {
  const [open, setOpen] = React.useState(false)
  const handleFullScreenClick = () => {
    const ele = document.querySelector('video')
    const video = document.getElementsByTagName('video')[0]
    if (!open) {
      setOpen(true)
      video.play()
    } else {
      setTimeout(() => {
        video.pause()
      }, 0)
      setOpen(false)
    }
    if (!document.fullscreenElement) {
      try {
        ele.requestFullscreen()
      } catch {
        ele.webkitEnterFullscreen()
      }
    } else {
      try {
        document.exitFullscreen()
      } catch {
        document.webkitExitFullscreen()
      }
    }
  }
  return (
    <Box className={styles['video-wrapper']}>
      <Typography variant="h2" sx={{ textAlign: 'center', mb: '43px' }}>
        How-to Video
      </Typography>
      <div
        onClick={handleFullScreenClick}
        style={{ margin: 'auto', position: 'relative' }}
      >
        <video
          id="product_video"
          preload="auto"
          poster={poster}
          className={styles.video}
        >
          <source src={video} type="video/mp4" />
          Your browser does not support
        </video>
        {!open && (
          <img
            src="/imgs/product/Accessories/play.svg"
            className={styles['video-button']}
            alt="play_button"
          />
        )}
        <Box className={styles['video-fullScreen']}>
          <InteractiveButton
            type="enlarge"
            isActive={false}
            isOpen={open ? 'yes' : ''}
          />
        </Box>
      </div>
    </Box>
  )
}

export default Video
